import { useCreateToken, useDeleteTokens, useGetTokens } from './useToken'

export const token = {
  get: useGetTokens,
  delete: useDeleteTokens,
  create: useCreateToken,
}
